import { localeEn, localeMe, localeSr, localeBa } from 'app-resources';
const messages = {
    en: localeEn,
    me: localeMe,
    sr: localeSr,
    ba: localeBa
};
// Mirrors the vue-i18n 11 Composer shape (II18n): ref-like locale, no tc —
// pluralization rides t's `count` named arg, like the real Composer.
class DefaultI18n {
    locale = { value: 'en' };
    /**
     * Get nested value from object using dot notation
     * e.g., "general.account" → messages.en.general.account
     */
    getNestedValue(obj, path) {
        return path.split('.').reduce((acc, key) => acc?.[key], obj);
    }
    /**
     * Interpolate named placeholders: {value}, {pricelist}, etc.
     * Example: "Receipt issued, value {value}" + {value: "100"} → "Receipt issued, value 100"
     */
    interpolate(message, params) {
        if (!params || typeof message !== 'string')
            return message;
        return message.replace(/\{(\w+)\}/g, (_, key) => params[key] !== undefined ? String(params[key]) : `{${key}}`);
    }
    /**
     * Handle pluralization: "Action | Actions"
     * choice=0,1 → first form, choice>=2 → second form
     */
    pluralize(message, choice) {
        if (typeof message !== 'string' || !message.includes('|'))
            return message;
        const forms = message.split('|').map(s => s.trim());
        const index = choice <= 1 ? 0 : Math.min(1, forms.length - 1);
        return forms[index] || message;
    }
    t(key, ...values) {
        let message = this.getNestedValue(messages[this.locale.value], key)
            || this.getNestedValue(messages['en'], key)
            || key;
        // Composer semantics (verified against vue-i18n 11): a message with
        // plural forms resolves even without a count — choice defaults to 1;
        // a numeric `count` named arg selects the form and stays interpolatable.
        const params = values[0];
        const count = params && typeof params === 'object' && typeof params.count === 'number'
            ? params.count
            : 1;
        message = this.pluralize(message, count);
        if (params && typeof params === 'object') {
            message = this.interpolate(message, params);
        }
        return message;
    }
}
export const defaultI18n = new DefaultI18n();
//# sourceMappingURL=DefaultI18n.js.map